// Index metadata for the System Design section.
// Full article content lives in systemDesignArticles.js.

export const systemDesignIndex = [
  // Core Concepts
  {
    id: 'cap-theorem',
    title: 'CAP Theorem',
    description: 'Consistency, Availability, Partition Tolerance. You can only pick two.',
    category: 'Core Concept',
    difficulty: 'Beginner',
    readTime: '8 min',
    complexity: 2,
    tags: ['Distributed Systems', 'Theory'],
    prerequisites: [],
    relatedArticles: ['load-balancing', 'caching'],
    interviewFrequency: 'Must Know',
    order: 1,
  },
  {
    id: 'load-balancing',
    title: 'Load Balancing',
    description: 'Distributing network traffic across multiple servers for high availability and reliability.',
    category: 'Core Concept',
    difficulty: 'Beginner',
    readTime: '10 min',
    complexity: 2,
    tags: ['Networking', 'Scaling'],
    prerequisites: [],
    relatedArticles: ['cap-theorem', 'caching'],
    interviewFrequency: 'Must Know',
    order: 2,
  },
  {
    id: 'caching',
    title: 'Caching Strategies',
    description: 'Techniques to store frequently accessed data in memory for faster retrieval.',
    category: 'Core Concept',
    difficulty: 'Beginner',
    readTime: '10 min',
    complexity: 2,
    tags: ['Performance', 'Storage'],
    prerequisites: [],
    relatedArticles: ['load-balancing', 'url-shortener'],
    interviewFrequency: 'Must Know',
    order: 3,
  },
  {
    id: 'consistent-hashing',
    title: 'Consistent Hashing',
    description: 'Distributing data across nodes so that adding or removing a server only remaps a small fraction of keys.',
    category: 'Core Concept',
    difficulty: 'Intermediate',
    readTime: '12 min',
    complexity: 3,
    tags: ['Distributed Systems', 'Scaling'],
    prerequisites: ['load-balancing'],
    relatedArticles: ['database-sharding', 'caching'],
    interviewFrequency: 'Commonly Asked',
    order: 4,
  },
  {
    id: 'database-sharding',
    title: 'Database Sharding',
    description: 'Horizontally partitioning data across multiple databases to handle massive scale and throughput.',
    category: 'Core Concept',
    difficulty: 'Intermediate',
    readTime: '14 min',
    complexity: 4,
    tags: ['Database', 'Scaling'],
    prerequisites: ['consistent-hashing'],
    relatedArticles: ['consistent-hashing', 'url-shortener'],
    interviewFrequency: 'Must Know',
    order: 5,
  },
  // Case Studies
  {
    id: 'url-shortener',
    title: 'Design TinyURL',
    description: 'System to shorten long URLs. Covers architecture, database design, API endpoints, and scaling.',
    category: 'Case Study',
    difficulty: 'Intermediate',
    readTime: '25 min',
    complexity: 3,
    tags: ['API Design', 'Database', 'Caching', 'Scaling'],
    prerequisites: ['caching', 'load-balancing'],
    relatedArticles: ['rate-limiter', 'whatsapp'],
    interviewFrequency: 'Must Know',
    order: 6,
  },
  {
    id: 'rate-limiter',
    title: 'Design a Rate Limiter',
    description: 'Build a distributed rate limiter to protect APIs from abuse. Token bucket, sliding window, and Redis-based implementations.',
    category: 'Case Study',
    difficulty: 'Intermediate',
    readTime: '18 min',
    complexity: 3,
    tags: ['API Design', 'Distributed Systems', 'Caching'],
    prerequisites: ['caching'],
    relatedArticles: ['url-shortener', 'load-balancing'],
    interviewFrequency: 'Commonly Asked',
    order: 7,
  },
  {
    id: 'whatsapp',
    title: 'Design WhatsApp',
    description: 'Real-time messaging system with delivery receipts, presence, and group chat.',
    category: 'Case Study',
    difficulty: 'Intermediate',
    readTime: '15 min',
    complexity: 4,
    tags: ['Real-Time', 'WebSocket', 'Storage'],
    prerequisites: ['load-balancing', 'database-sharding'],
    relatedArticles: ['url-shortener', 'rate-limiter'],
    interviewFrequency: 'Commonly Asked',
    order: 8,
  },
];
